import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';
import { PlcTagDto } from 'src/dtos/plcTag/plcTagDto';
import { EQM1011_R01Dto } from './Dto_EQM1011_R01';

export interface EQM1011_R01Filter {
    compCd: string;
    tagId: string; // 데이터종류(plc_tag.tag_id). 빈 문자열이면 전체. 옛 plcaddressid(숫자) 대체
    baseDate: Date | undefined;
}

export interface Store_EQM1011_R01 {
    EQM1011_R01Filter: EQM1011_R01Filter;
    setEQM1011_R01Filter: (filter: Partial<EQM1011_R01Filter>) => void;

    EQM1011_R01List: EQM1011_R01Dto[];
    setEQM1011_R01List: (list: EQM1011_R01Dto[]) => void;

    EQM1011_R01TagList: PlcTagDto[]; // "데이터종류" 선택 목록(사용 중인 PLC 태그). 화면 진입 시 1회 조회하는 기준정보
    setEQM1011_R01TagList: (list: PlcTagDto[]) => void;

    columnState: ColumnState[] | null;
    setColumnState: (state: ColumnState[] | null) => void;
    scrollTop: number | null;
    setScrollTop: (top: number | null) => void;

    initData: () => void;
}

const createDefaultEQM1011_R01Filter = (): EQM1011_R01Filter => ({
    compCd: '',
    tagId: '',
    baseDate: new Date(),
});

export const defaultEQM1011_R01Filter = createDefaultEQM1011_R01Filter();

export const useEQM1011_R01Store = create<Store_EQM1011_R01>((set) => {
    return {
        EQM1011_R01Filter: createDefaultEQM1011_R01Filter(),
        setEQM1011_R01Filter: (filter) => set((state) => ({
            EQM1011_R01Filter: { ...state.EQM1011_R01Filter, ...filter },
        })),

        EQM1011_R01List: [],
        setEQM1011_R01List: (list) => set({ EQM1011_R01List: list }),

        EQM1011_R01TagList: [],
        setEQM1011_R01TagList: (list) => set({ EQM1011_R01TagList: list }),

        columnState: null,
        setColumnState: (state) => set({ columnState: state }),
        scrollTop: null,
        setScrollTop: (top) => set({ scrollTop: top }),

        // 초기화 버튼은 검색조건·목록만 비운다. 데이터종류 선택 목록(EQM1011_R01TagList)은 기준정보라 유지한다(비우면 화면을 다시 열 때까지 선택지가 사라짐)
        initData: () => set({
            EQM1011_R01Filter: createDefaultEQM1011_R01Filter(),
            EQM1011_R01List: [],
            columnState: null,
            scrollTop: null,
        }),
    };
});
